import React, {FC, lazy, Suspense} from 'react';
import Souhait from '../screens/Souhait';
import OccasionPage, {occasionForPath} from '../screens/OccasionPage';

const UiKit = lazy(() => import('../screens/UiKit'));

const App: FC = () => {
  const occasion = occasionForPath(window.location.pathname);
  if (occasion) return <OccasionPage occasion={occasion} />;
  return window.location.pathname === '/ui-kit' ? (
    <Suspense fallback={<p role="status">Loading the UI kit…</p>}>
      <UiKit />
    </Suspense>
  ) : (
    <Souhait />
  );
};

export default App;
